export const SET_COMMUNICATION_CONTEXT = 'SET_COMMUNICATION_CONTEXT'

// NOTES
export const SET_REMARKS = 'SET_REMARKS'
export const REMARK_CHANGED = 'REMARK_CHANGED'

// CHECKS
export const SET_CHECK_LISTS = 'SET_CHECK_LISTS'
export const SET_CHECKS = 'SET_CHECKS'
export const SET_CHECK_FOLLOWER_IDS = 'SET_CHECK_FOLLOWER_IDS'
export const TOGGLE_CHECK_NOT_APPLICABLE = 'TOGGLE_CHECK_NOT_APPLICABLE'

// CHECKINS
export const SET_CHECKINS = 'SET_CHECKINS'
export const ADD_CHECKIN = 'ADD_CHECKIN'
export const ADD_CHECKIN_PENDING = 'ADD_CHECKIN_PENDING'
export const DELETE_CHECKIN = 'DELETE_CHECKIN'

// USERS
export const SET_USERS = 'SET_USERS'

// CONTEXTS
export const SET_CONTEXTS = 'SET_CONTEXTS'

// COMMENTS
export const SET_COMMENTS = 'SET_COMMENTS'

// ATTACHMENTS
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS'
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'

// REMARKS
export const SET_TODO_DONE = 'SET_TODO_DONE'

// COMMENTS
export const ADD_COMMENT = 'ADD_COMMENT'
export const EDIT_COMMENT = 'EDIT_COMMENT'

// REMARK TAGS
export const SET_ALL_REMARK_TAGS = 'SET_ALL_REMARK_TAGS'
export const SET_WORKFLOW_REVIEW_TAGS = 'SET_WORKFLOW_REVIEW_TAGS'
export const SET_WORKFLOW_REVIEW_ACTIVE_TAG = 'SET_WORKFLOW_REVIEW_ACTIVE_TAG'

// UI
export const TOGGLE_SHOWING_COMPLETED_TODOS = 'TOGGLE_SHOWING_COMPLETED_TODOS'
export const TOGGLE_SHOWING_COMPLETED_CHECK_LISTS =
  'TOGGLE_SHOWING_COMPLETED_CHECK_LISTS'
export const ADD_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID =
  'ADD_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID'
export const REMOVE_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID =
  'REMOVE_SHOWING_COMPLETED_CHECKS_IN_CHECK_LIST_ID'
export const SET_REMARK_FOLLOWER_IDS = 'SET_REMARK_FOLLOWER_IDS'
export const SET_REMARK_STICKY = 'SET_REMARK_STICKY'
export const ADD_NEW_COMMENT_REMARK_ID = 'ADD_NEW_COMMENT_REMARK_ID'
export const ADD_NEW_COMMENT_CHECK_ID = 'ADD_NEW_COMMENT_CHECK_ID'

export const ADD_NEW_COMMENT_ASSISTANT_CHECK_ID =
  'ADD_NEW_COMMENT_ASSISTANT_CHECK_ID'

export const REMOVE_NEW_COMMENT_REMARK_ID = 'REMOVE_NEW_COMMENT_REMARK_ID'
export const REMOVE_NEW_COMMENT_CHECK_ID = 'REMOVE_NEW_COMMENT_CHECK_ID'

export const REMOVE_NEW_COMMENT_ASSISTANT_CHECK_ID =
  'REMOVE_NEW_COMMENT_ASSISTANT_CHECK_ID'

export const ADD_EDIT_COMMENT_ID = 'ADD_EDIT_COMMENT_ID'
export const REMOVE_EDIT_COMMENT_ID = 'REMOVE_EDIT_COMMENT_ID'
export const SET_MENTION_USERNAMES = 'SET_MENTION_USERNAMES'
export const SET_PULSE_USERNAMES = 'SET_PULSE_USERNAMES'
export const RESET_MENTION_USERNAMES = 'RESET_MENTION_USERNAMES'
export const START_FETCHING_COMMUNICATIONS = 'START_FETCHING_COMMUNICATIONS'
export const STOP_FETCHING_COMMUNICATIONS = 'STOP_FETCHING_COMMUNICATIONS'
export const RESET_FETCHING_COMMUNICATIONS = 'RESET_FETCHING_COMMUNICATIONS'
export const TOGGLE_DROPDOWN = 'TOGGLE_DROPDOWN'
export const CLOSE_DROPDOWN = 'CLOSE_DROPDOWN'

export const SET_LOADING = 'SET_LOADING'
